import { render, staticRenderFns } from "./binding5.vue?vue&type=template&id=212ead32&scoped=true&"
import script from "./binding5.vue?vue&type=script&lang=js&"
export * from "./binding5.vue?vue&type=script&lang=js&"
import style0 from "./binding5.vue?vue&type=style&index=0&id=212ead32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ead32",
  null
  
)

export default component.exports